import React, { useMemo } from 'react';
import { SignupFormikContext } from '@jetshop/core/components/Auth/signup-context';
export default function useSignupForm() {
    var _a, _b;
    const { formik } = React.useContext(SignupFormikContext);
    const isSignupError = (_a = formik === null || formik === void 0 ? void 0 : formik.status) === null || _a === void 0 ? void 0 : _a.isSignupError;
    const validationDetails = (_b = formik === null || formik === void 0 ? void 0 : formik.status) === null || _b === void 0 ? void 0 : _b.validationDetails;
    return useMemo(() => ({
        isSignupError,
        validationDetails: validationDetails,
        isSubmitting: formik.isSubmitting,
        handleSubmit: formik.handleSubmit
    }), [formik.handleSubmit, formik.isSubmitting, isSignupError, validationDetails]);
}
//# sourceMappingURL=useSignupForm.js.map